import { combineReducers } from "redux";
import projectReducer from "./projectReducer";
import commonReducer from "./commonReducer";
import UserReducer from "./UserReducer";
import lookupReducer from "./lookupReducer";
import AddNewShipReducer from "./AddNewShipReducer";

const rootReducer = combineReducers({
    projectReducer,
    commonReducer,
    UserReducer,
    lookupReducer,
    AddNewShipReducer
});

export default rootReducer;
